import { Component, OnInit } from '@angular/core';
import { TelecomService } from 'src/app/services/telecom/telecom.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-voicemail-extension',
  templateUrl: './voicemail-extension.component.html',
  styleUrls: ['./voicemail-extension.component.css']
})
export class VoicemailExtensionComponent implements OnInit {

  config_data: Array<any> = [];
  config_filteredData: Array<any> = [];
  filterString: string = "";
  syncDisabled: boolean = false;
  downloadDisabled: boolean = true;
  blankOnly: boolean = false;
  formValid: boolean = true;

  bluePrint = {
    agentId:"",
    deliveryEmail: true,
    deliveryOptions: {
      email: true,
      sms: {
        enabled: false,
        phoneNumber: "null"
      }
    },
    encryptVoicemail: false,
    extension: null,
    transcribeVoicemail: true,
    userId:"",
    username:""
  }

  lambdaMessage: string = "";
  lambdaError: boolean = false;

  constructor(private telecomService: TelecomService) { }

  ngOnInit(): void {
    this.config_getUsers();
  }

  config_getUsers() {
    this.downloadDisabled = true;
    this.config_data = [];
    this.getUserBatch("");
    this.downloadDisabled = false;
  }

  getUserBatch(next: string) {
    let payload = {
      queryStringParameters: {
        size: 1000
      }
    };
    if (next !== "") {
      payload.queryStringParameters['next'] = next;
    }
    const params = {
      FunctionName: environment.AgentsGetLambdaName,
      Payload: JSON.stringify(payload)
    }
    this.telecomService.callLambda(params, "Failed to retrieve voicemail agents from connect.").then((response: any) => {
      if (response.statusCode != 200) {
        this.lambdaError = true;
        this.lambdaMessage = "Failed to retrieve Voicemail Users from Connect";
      } else {
        const parsed = JSON.parse(response.body);
        let temp = JSON.parse(JSON.stringify(this.config_data));                    //make a copy
        this.config_data = JSON.parse(JSON.stringify(temp.concat(parsed.data)));    //original = copy + new
        this.applyFilter(this.filterString);
        if (parsed.hasOwnProperty("next")) {
          this.getUserBatch(parsed.next);
        }
      }
    });
  }

  config_sync() {
    this.lambdaError = false;
    this.lambdaMessage = "Syncing users...";
    console.log("sync");
    const params = {
      FunctionName: environment.ConnectSyncRequestLambdaName,
      Payload: JSON.stringify({})
    }
    this.telecomService.callLambda(params, "Failed to sync voicemail configuration").then((response: any) => {
      console.log("config_sync response: ", response);
      if (response.statusCode != 200) {
        alert("Failed to sync voicemail configuration, please try again")
      } else {
        this.lambdaError = false;
        this.lambdaMessage = "Synced successfully"
        this.config_getUsers();
      }
    });
  }

  config_updateAgent(item: any) {
    let phone = item.deliveryOptions.sms.phoneNumber;
    if (phone == 'null') {
      phone = null;
    }
    let body = {
      "extension": item.extension,
      "deliverSMSPhoneNumber": phone,
      "deliverSMS": item.deliveryOptions.sms.enabled,
      "deliverEmail": item.deliveryOptions.email,
      "encryptVoicemail": item.encryptVoicemail,
      "transcribeVoicemail": item.transcribeVoicemail
    }
    if (body.extension === "") {
      body.extension = null;
    }
    const params = {
      FunctionName: environment.UpdateConnectUserLambdaName,
      Payload: JSON.stringify({
        "username": item.Username,
        "operation": "put",
        "extension": body.extension,
      })
    }
    console.log("updateAgent payload: ", params.Payload);
    this.telecomService.callLambda(params, "Failed to update voicemail configuration.").then((response: any) => {
      console.log("updateAgent response: ", response);
      if (response.status != 200) {
        this.lambdaError = true;
        this.lambdaMessage = "Failed to update agent:" + response.message;
      } else {
        this.config_updateLocalData(item);
      }
      this.config_getUsers()
      this.applyFilter(this.filterString);
    });
  }

  config_deleteAgent(item: any) {
    let phone = item.deliveryOptions.sms.phoneNumber;
    if (phone == 'null') {
      phone = null;
    }
    let body = {
      "extension": item.extension,
      "deliverSMSPhoneNumber": phone,
      "deliverSMS": item.deliveryOptions.sms.enabled,
      "deliverEmail": item.deliveryOptions.email,
      "encryptVoicemail": item.encryptVoicemail,
      "transcribeVoicemail": item.transcribeVoicemail
    }
    // if (body.extension === "") {
    //   body.extension = null;
    // }
    const params = {
      FunctionName: environment.UpdateConnectUserLambdaName,
      Payload: JSON.stringify({
        "operation": "delete",
        "extension": body.extension
      })
    }
    console.log("updateAgent payload: ", params.Payload);
    this.telecomService.callLambda(params, "Failed to delete voicemail extension.").then((response: any) => {
      console.log("updateAgent response: ", response);
      if (response.status != 200) {
        this.lambdaError = true;
        this.lambdaMessage = "Failed to update agent:" + response.message;
      } else {
        this.config_updateLocalData(item);
      }
      this.config_getUsers()
      this.applyFilter(this.filterString);
    });
  }

  config_updateLocalData(item: any) {
    for (let x = 0; x < this.config_data.length; x++) {
      if (this.config_data[x].Username == item.Username) {
        this.config_data[x] = item
      }
    }
  }

  applyFilter(searchString: string) {
    console.log("applying filter");

    //filter
    if (this.blankOnly) {
      this.config_filteredData = [];
      for (let x = 0; x < this.config_data.length; x++) {
        if (this.config_data[x].hasOwnProperty("Extension")) {
          if (this.config_data[x].Extension.trim() == "") {
            this.config_filteredData.push(this.config_data[x]);
          }
        } else {
          this.config_filteredData.push(this.config_data[x]);
        }
      }
    } else {
      this.config_filteredData = JSON.parse(JSON.stringify(this.config_data));
    }
  }

  config_handleItemChange(evt: any) {
    console.log("evt:", evt);
    console.log("evt button:", evt.button);
    
    let item = evt.item;
    console.log("item", evt.item);
    console.log("Extension", evt.item.Extension);
    if (evt.button == "confirm") {
      if (!item.deliveryOptions) {
        let copy = JSON.parse(JSON.stringify(this.bluePrint));
        console.log("Copy", copy);
        copy.Username = evt.item.Username;
        copy.userId =  evt.item.userId;
        copy.agentId =  evt.item.agentId;
        copy.extension =  evt.item.Extension;
        item = copy
      }
      this.config_updateAgent(item);
      this.config_getUsers()
    } 
    else if (evt.button == "delete") {
      if (!item.deliveryOptions) {
        let copy = JSON.parse(JSON.stringify(this.bluePrint));
        copy.Username = evt.item.Username;
        copy.userId =  evt.item.userId;
        copy.agentId =  evt.item.agentId;
        copy.extension =  evt.item.Extension;
        item = copy
        console.log("Ext Delete Ext:", evt.item.Extension);
      }
      this.config_deleteAgent(item);
      this.config_getUsers()
    }
    this.applyFilter(this.filterString);
  }

  config_validate(item: any) {
    this.lambdaMessage = '';
    this.lambdaError = false;

    console.log(item.Extension);

    if (String(item.Extension).substring(0, 1) == '+') {
      if (!/^\+\d{10}/.test(item.Extension)) {
        this.lambdaError = true;
        this.lambdaMessage = "Extensions starting with '+' must be 10 digits long"
        return false;
      }
    } else if (item.Extension.length != 0 && !/^\d+$/.test(item.Extension)) {
      this.lambdaError = true;
      this.lambdaMessage = "Extensions must be only numeric characters"
      return false;
    }

    if (item.Extension.length < 7 && item.Extension.length != 0 && item.Extension != null && item.Extension == undefined) {
      this.lambdaError = true;
      this.lambdaMessage = "Extensions must have 7 or more characters"
      return false;
    }

    for (let x = 0; x < this.config_data.length; x++) {
      const temp = this.config_data[x];
      if (temp.Extension == item.Extension && temp.agentId != item.agentId && temp.Extension != "") {
        this.lambdaError = true;
        this.lambdaMessage = 'Extension already in use'
        return false;
      }
    }

    return true;
  }

  buildCSV() {
    //create csv
    let csvContent = "data:text/csv;charset=utf-8,";
    csvContent += "Username,Extension\r\n";
    this.config_data.forEach(rowObject => {
      let rowArray = [rowObject.Username, rowObject.Extension]
      csvContent += rowArray.join(',') + "\r\n";
    });
    console.log("csvContent: ", csvContent);

    //download
    let encodedUri = encodeURI(csvContent);
    let link = document.getElementById("downloadLink");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "AgentExtensions.csv");
    link.click();
  }
}
